import { DocumentContext, DocumentInfo, DocumentType, IpRightsDocuments } from 'src/renewal/interfaces/Documents'
import { useDocumentInfo, useDocumentsPerId, DocumentInfo as DmDocumentInfo, useDocumentAcknowledge, useDennemeyer } from '../DennemeyerProvider'
import { download_document } from '../dennemeyer_backend';

// id is a numeric id
export function DennemeyerDocument({ id, children }: { id: string; children: React.ReactNode }) {
  const { documentInfo, downloadDocument } = useDocumentInfo(+id)

  const value = {
    info: toInfo(documentInfo),
    download: () => downloadDocument(documentInfo.DocumentName),
  }
  // console.log({ value, documentInfo })
  return (
    <DocumentContext.Provider {...{ value }}>
      {children}
    </DocumentContext.Provider>
  )
}

export function DennemeyerIpRightDocuments({ ipRightId, children }: { ipRightId: string; children: React.ReactNode }) {
  const { ipRightById } = useDennemeyer()
  const {acknowledge} = useDocumentAcknowledge()
  const ipRight = ipRightById[ipRightId]
  const {documents: documentsResponse} = useDocumentsPerId(ipRight?.dennemeyerId)
  // console.log({ipRightById, documentsResponse, ipRightId})

  async function download(id: string, filename: string) {
    await download_document(id, filename)
    return acknowledge(id)
  }

  const documents = documentsResponse?.Data?.Page?.map(d => toInfo(d)) ?? []

  const value = {
    documents,
    download,
  }

  return <IpRightsDocuments.Provider {...{ value }}>{children}</IpRightsDocuments.Provider>
}

function toInfo(d?: DmDocumentInfo): DocumentInfo {
  if (!d) return null
  return {
    id: '' + d.DennemeyerId,
    created: d.DocumentDate,
    filename: d.DocumentName,
    type: toDocumentType(d.DocumentType),
  }
}

function toDocumentType(type: string): DocumentType {
  switch (type) {
    case 'Annuity certificate':
      return 'annuity-certificate'
    case "renewal certificate":
    case "recordal certificate":
      return 'certificate'
    case 'RenewalNotice':
      return 'renewal-notice'
    case 'DebitNote':
      return 'debit-note'
    case "debit note":
      return 'debit-note'
    case "renewal notice":
      return 'renewal-notice'
    case "renewal filing receipts":
    default:
      return 'other'
  }
}
